module.exports = __webpack_public_path__ + "img/142-tibet.5be2430d.svg";